<div class="general cycle__child spacing--padding-all spacing--margin-all" data-test="general">
  <form [formGroup]="form" [agrConnectForm]="information$" (ngSubmit)="save()">
    <div class="flex--column">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'cycle-number' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          placeholder="{{ 'cycle-number' | translate }}"
          formControlName="cycleNumber"
          data-test="general__couple-number"
          [readonly]="isEditingGeneral$ | async"
        />
        <mat-error *ngIf="form.controls.cycleNumber.invalid">
          {{ 'error-cycle-number' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'concept' | translate }}</mat-label>
        <mat-select
          [hideSingleSelectionIndicator]="true"
          [compareWith]="compareConcept"
          formControlName="concept"
          data-test="general__concept"
        >
          <mat-option *ngFor="let concept of concepts$ | async" [value]="concept">
            {{ concept.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.concept.invalid">
          {{ 'error-concept' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="isFreeRange()" class="flex__child--auto">
        <mat-label>{{ 'time-in-free-range' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="1"
          formControlName="timeInFreeRange"
          placeholder="{{ 'time-in-free-range' | translate }}"
          data-test="general__time-in-free-range"
        />
        <span matTextSuffix class="form-field-suffix">%</span>
        <mat-error
          *ngIf="
            form.controls.timeInFreeRange.hasError('min') ||
            form.controls.timeInFreeRange.hasError('max')
          "
        >
          {{ 'time-in-free-range-error' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'app.reference-value-sheet' | translate }}</mat-label>
        <mat-select
          [hideSingleSelectionIndicator]="true"
          formControlName="referenceValueSheetId"
          data-test="general__refValSheet"
        >
          <mat-option [value]="null">{{ 'cycle-overview.placeholder' | translate }}</mat-option>
          <mat-option *ngFor="let refValSheet of refValSheets$ | async" [value]="refValSheet.id">
            {{ refValSheet.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.referenceValueSheetId.invalid">
          {{ 'error-refValSheet' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'app.feed-advice' | translate }}</mat-label>
        <mat-select
          [hideSingleSelectionIndicator]="true"
          formControlName="feedAdviceId"
          data-test="general__feedAdvice"
        >
          <mat-option [value]="null">{{ 'cycle-overview.placeholder' | translate }}</mat-option>
          <mat-option *ngFor="let feedAdvice of feedAdvices$ | async" [value]="feedAdvice.id">
            {{ feedAdvice.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.feedAdviceId.invalid">
          {{ 'error-feedAdvice' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'cycle-description' | translate }}</mat-label>
        <input
          matInput
          placeholder="{{ 'cycle-description' | translate }}"
          formControlName="cycleDescription"
          data-test="general__cycle-description"
        />
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'transport-distance' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="1"
          formControlName="transportDistance"
          placeholder="{{ 'transport-distance' | translate }}"
          data-test="general__transport-distance"
        />
        <span matTextSuffix class="form-field-suffix">km</span>
        <mat-error
          *ngIf="
            form.controls.transportDistance.hasError('min') ||
            form.controls.transportDistance.hasError('max')
          "
        >
          {{ 'transport-distance-error' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'bedding-type' | translate }}</mat-label>
        <mat-select
          [hideSingleSelectionIndicator]="true"
          formControlName="beddingType"
          data-test="general__bedding-type"
        >
          <mat-option *ngFor="let beddingType of beddingTypes" [value]="beddingType">
            {{ 'bedding-types.' + beddingType | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'bedding-amount' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          formControlName="beddingAmount"
          placeholder="{{ 'bedding-amount' | translate }}"
          data-test="general__bedding-amount"
        />
        <span matTextSuffix class="form-field-suffix">kg</span>
        <mat-error *ngIf="form.controls.beddingAmount.hasError('min')">
          {{ 'bedding-amount-error' | translate }}
        </mat-error>
      </mat-form-field>

      <div *ngIf="shouldShowWDOsettings() | async" class="wdo-settings">
        <h6 class="text--h6">{{ 'wdo-settings.title' | translate }}</h6>
        <span class="float-left">
          <a
            [routerLink]=""
            mat-link-button
            (click)="openWDOsettings()"
            data-test="general__open_wdo-settings"
          >
            {{ 'wdo-settings.open-settings' | translate }}
          </a>
        </span>
      </div>

      <div class="spacing--margin-top mat-button-row">
        <button
          type="submit"
          mat-flat-button
          class="flex__child"
          color="primary"
          data-test="general__save"
        >
          {{ 'save' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
